<template>
  <div>
    <dx-data-grid
      ref="refPurchaseDetailGrid"
      :height='gridHeight'
      :data-source="purchaseInoutInfoDetail"
      :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
      :hover-state-enabled = "true" :allowColumnResizing = 'true'
      column-resizing-mode = 'widget' :allow-column-reordering = "true"
      :row-alternation-enabled="true"
      :focused-row-enabled="true"
      :auto-navigate-to-focused-row="true"
      @cell-prepared="onCellPrepared"
      key-expr="seqId"
      @toolbar-preparing='onToolbarPreparing'
    >
      <DxSearchPanel
        :visible="true"
        placeholder="검색..."
      />
      <DxExport
        :enabled="true"
        :file-name="exportTitle"
      />
      <DxFilterRow
        :visible="true"
        apply-filter="auto"
      />
      <DxColumn
        :allowEditing='false'
        caption="입출고일"
        data-field="발생일자"
        dataType='date'
        format='yyyy-MM-dd'>
      </DxColumn>
      <DxColumn
        :allowEditing='false'
        caption="마감월"
        data-field="마감일자"
        dataType='date'
        format='yyyy-MM'>
      </DxColumn>
      <DxColumn
        :allowEditing='false'
        caption="품번"
        data-field="품번"
      >
      </DxColumn>
      <DxColumn
        :allowEditing='false'
        :fixed="false"
        caption="품명"
        data-field="품명"
        :visible='true'
      >
      </DxColumn>
      <DxColumn
        :allowEditing='false'
        caption="자재유형"
        data-field="자재유형"
        :visible='true'
      >
        <DxLookup
          :data-source="meterialTypeLookup"
          display-expr="코드명"
          value-expr="코드"
        />
      </DxColumn>
      <DxColumn
        :allowEditing='false'
        caption="재질"
        data-field="재질"
        :visible='true'
      >
      </DxColumn>
      <DxColumn
        :allowEditing='false'
        caption="구분"
        data-field="입출고구분"
        :visible='true'
        sort-order='desc'
      >
        <DxLookup
          :data-source="receiptTypeLookup"
          display-expr="코드명"
          value-expr="코드"
        />
      </DxColumn>
      <DxColumn
        :allowEditing='true'
        caption="단위"
        data-field="단위"
        :visible='true'
      >
        <DxLookup
          :data-source="unitLookup"
          display-expr="코드명"
          value-expr="코드"
        />
      </DxColumn>
      <DxColumn
        :allowEditing='true'
        caption="수량"
        data-field="수량"
        :visible='true'
        format='#,##0'
        dataType="number"
      >
      </DxColumn>
      <DxColumn
        :allowEditing='false'
        caption="단가"
        data-field="단가"
        :visible='true'
        format='#,##0'
        dataType="number"
      >
      </DxColumn>
      <DxColumn
        :allowEditing='false'
        caption="금액"
        data-field="금액"
        :calculate-cell-value="calcAmount"
        :visible='true'
        format='#,##0'
        dataType="number"
      >
      </DxColumn>
      <DxColumn
        :allowEditing='false'
        :visible="false"
        caption="파레트번호"
        data-field="입고키"
        format='#,##0'
        dataType="number"
      >
      </DxColumn>
      <DxColumn
        :allowEditing='false'
        :visible="false"
        caption="거래처"
        data-field="거래처명"
      >
      </DxColumn>
        <DxColumn
        :allowEditing='false'
        caption="LOT_NO"
        data-field="lotNo"
        :visible='true'
      >
      </DxColumn>
      <DxSummary>
        <DxTotalItem
          value-format='#,##0'
          column="발생일자"
          display-format="{0} (건)"
        />
        <DxTotalItem
          value-format='#,##0'
          summary-type="sum"
          column="금액"
          display-format="{0}"
        />
      </DxSummary>
      <dx-paging :enabled="false"/>
      <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
      <dx-sorting mode="multiple"/>
      <template #company-sub>
        <div class="toolbar-label" style='font-size:1.2rem;margin-left:0px;'>
          <b>협력사: {{item.data.거래처명}}</b>
        </div>
      </template>
    </dx-data-grid>
  </div>
</template>

<script>
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxTotalItem,
  DxSummary, DxColumn, DxPaging, DxSorting, DxSearchPanel, DxLookup } from 'devextreme-vue/data-grid'

export default {
  name: 'RawMaterialsInOutDetailTemp',
  data: function () {
    return {
      gridHeight: 300,
      purchaseInoutInfoDetail: null,
      meterialTypeLookup: null,
      unitLookup: null,
      excelFileName: null,
      mrpExcelExportInfo: [],
      receiptTypeLookup: null,
      exportTitle: null
    }
  },
  props: {
    item: {
      type: Object,
      default: null
    },
    thisYear: {
      type: Number,
      default: 2022
    },
    thisMonth: {
      type: String,
      default: '04'
    },
    isYear: {
      type: Boolean,
      default: false
    }
  },
  components: {
    DxColumn,
    DxScrolling,
    DxPaging,
    DxLookup,
    DxDataGrid,
    DxExport,
    DxSummary,
    DxTotalItem,
    DxSorting,
    DxSearchPanel,
    DxFilterRow
  },
  created () {
    this.meterialTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.자재유형)
    this.unitLookup = this.$store.getters.getBaseDataByType(ConstDef.단위)
    this.receiptTypeLookup = ConstDef.PURCHASE_INOUT_CODE
  },
  mounted () {
    this.refreshPurchaseDetail(this.item.data.입고업체)
    if (this.isYear) {
      this.exportTitle = `${this.thisYear}년-${this.item.data.거래처명}-구매-사급내역서`
    } else {
      this.exportTitle = `${this.thisYear}년${this.thisMonth}월-${this.item.data.거래처명}-구매-사급내역서`
    }
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    calcAmount (row) {
      let result = row.수량 * row.가격
      if (row.입출고구분 === ConstDef.사급출고) {
        result *= -1
      }
      return result
    },
    onCellPrepared (e) {
      if (e.rowType === 'data' && e.column.dataField === '금액' && e.data.입출고구분 === ConstDef.사급출고) {
        this.$Q(e.cellElement).css('color', 'red')
      }
    },
    onToolbarPreparing (e) {
      console.log(e)
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: 'company-sub'
        }
      )
    },
    refreshPurchaseDetail (company) {
      console.log(company)
      let param
      console.log(this.isYear)
      if (this.isYear === true) {
        let endDate = AppLib.calcDateFromFormat(`${this.thisYear}-12-31`, 1)
        console.log(endDate)
        param = {
          fromDate: `${this.thisYear}-01-01`,
          toDate: `${endDate}`,
          company: company
        }
      } else {
        let endDate = `${this.thisYear}-${this.thisMonth}-${AppLib.getMonthLastDay(this.thisYear, this.thisMonth)}`
        endDate = AppLib.calcDateFromFormat(endDate, 1)
        param = {
          fromDate: `${this.thisYear}-${this.thisMonth}-01`,
          toDate: `${endDate}`,
          company: company
        }
      }
      this.$_sp.runNoEncodeFindProc('spFindAllMaterialsInOutSummaryByDateAndCompanyWith', param)
        .then((data) => {
          this.purchaseInoutInfoDetail = this.$_sp.MakeModel(data)
          console.log(this.purchaseInoutInfoDetail)
        })
        .catch(error => {
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">
.dx-master-detail-cell {
  padding-top: 8px!important;
}
</style>
